module.exports = __webpack_public_path__ + "static/media/1-2.11cae57d.jpg";